import v35 from './v35.js';
import md5 from './md5.js';
var v3 = v35('v3', 0x30, md5);
export default v3;


//////////////////
// WEBPACK FOOTER
// ./~/uuid/dist/esm-browser/v3.js
// module id = oYS7
// module chunks = 1